import React, { FC } from 'react';
import { MUIFieldProps } from '../../../../../lib/types/types';

import '@mdxeditor/editor/style.css';
import {
	MDXEditor,
	UndoRedo,
	BoldItalicUnderlineToggles,
	toolbarPlugin,
	ListsToggle,
	Separator,
	listsPlugin,
} from '@mdxeditor/editor';
import { MAX_TEXTBOX_LENGTH } from '../../../../../lib/constants/constant';
import { Box, Typography } from '@mui/material';
import { get } from 'lodash';

const MarkdownEditor: FC<MUIFieldProps> = (props) => {
	const { label, fieldValue, updateFieldValue, isDisabled, error, errorMessage, ...restProps } = props;

	const maxAllowCharacterLength = get(props, 'maxLength', MAX_TEXTBOX_LENGTH);

	const handleChange = (value: any) => {
		let event = { target: { value: value.slice(0, maxAllowCharacterLength) } };
		updateFieldValue(event as React.ChangeEvent<HTMLInputElement>);
	};
	return (
		<>
			<Box sx={{ marginTop: '1rem' }}>
				<Typography variant="body1" sx={{ color: error ? 'error.main' : isDisabled ? 'text.secondary' : 'text.primary' }}>
					{label}
				</Typography>
				<Typography variant="body2" sx={{ color: error ? 'error.main' : isDisabled ? 'text.secondary' : 'text.primary' }}>
					<em>{get(props, 'placeholder', '')}</em>
				</Typography>
				<MDXEditor
					className={`buit-markdown-editor${error ? '-error' : ''} dark-theme dark-editor`}
					markdown={fieldValue}
					onChange={handleChange}
					plugins={[
						listsPlugin(),
						toolbarPlugin({
							toolbarContents: () => (
								<>
									<UndoRedo />
									<Separator />
									<BoldItalicUnderlineToggles />
									<Separator />
									<ListsToggle options={['bullet', 'number']} />
									<Separator />
								</>
							),
						}),
					]}
					readOnly={isDisabled}
					{...restProps}
				/>
				{error && (
					<Typography variant="caption" color="error" sx={{ marginLeft: '1rem' }}>
						{errorMessage}
						<br></br>
					</Typography>
				)}
				<Typography variant="caption">
					{fieldValue.length + ' / ' + maxAllowCharacterLength + ' Zeichen (inkl. Leerzeichen) verwendet'}
				</Typography>
			</Box>
		</>
	);
};
export default MarkdownEditor;
